import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import PropertyName from 'automation-ui-references/object-type-properties/PropertyName';
import * as ObjectTypes from 'automation-ui-references/object-types/CRMObjectTypes';
import ObjectTypeName from 'automation-ui-references/object-types/ObjectTypeName';
import { jsx as _jsx } from "react/jsx-runtime";
const ClassicCopyCompanyPropertyActionDetail = ({
  actionMetadata,
  messageLangPath = 'actionDetail'
}) => {
  const {
    sourceProperty,
    targetProperty,
    targetObject
  } = actionMetadata;
  const targetObjectTypeId = targetObject === ObjectTypes.COMPANY ? ObjectTypes.COMPANY_ID : ObjectTypes.CONTACT_ID;
  const options = {
    targetObjectType: /*#__PURE__*/_jsx(ObjectTypeName, {
      objectTypeId: targetObjectTypeId
    }),
    targetObjectTypeCapitalized: /*#__PURE__*/_jsx(ObjectTypeName, {
      isCapitalized: true,
      objectTypeId: targetObjectTypeId
    }),
    sourcePropertyName: /*#__PURE__*/_jsx(PropertyName, {
      propertyName: sourceProperty,
      objectTypeId: ObjectTypes.COMPANY_ID
    }),
    targetPropertyName: /*#__PURE__*/_jsx(PropertyName, {
      propertyName: targetProperty,
      objectTypeId: targetObjectTypeId
    })
  };
  return messageLangPath === 'actionDetail' ? /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.classic-copy-company-property.action-detail.content",
    options: options
  }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.classic-copy-company-property.action-preview.content",
    options: options
  });
};
export default ClassicCopyCompanyPropertyActionDetail;